{
  "de": {
    "question": {
      "actions": {
        "addDocuments": "Dokumente hinzufügen",
        "cancel": "Abbrechen",
        "createQuestion": "Frage erstellen",
        "delete": "Löschen",
        "deleteDocuments": "Dokumente löschen",
        "edit": "Bearbeiten",
        "moveDown": "Nach unten verschieben",
        "moveUp": "Nach oben verschieben",
        "new": "Frage",
        "save": "Speichern"
      },
      "attributes": {
        "answer": "Antwort",
        "documents": "Dokumente / Bilder",
        "name": "Frage",
        "question": "Frage"
      },
      "labels": {
        "editQuestion": "Frage bearbeiten",
        "newQuestion": "Neue Frage"
      },
      "toasts": {
        "create": "Frage erstellt",
        "delete": "Frage gelöscht",
        "update": "Frage aktualisiert"
      },
      "validation": {
        "needAnswer": "Antwort erforderlich",
        "needQuestion": "Frage erforderlich"
      }
    }
  }
}
